import { useMutation } from '../';
import { updatePortfolioMutation } from '../mutations';

export function useUpdatePortfolioMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish, onError = () => { /* noop */ }) => {
    mutate(updatePortfolioMutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    }, () => {
      if (typeof onError === 'function') {
        onError();
      }
    });
  };

  return { data, isLoading, run };
}
